<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <h6>工厂及产品图片</h6>
        </div>
        <div>
          <a v-b-toggle.collapse-panel role="button" style="color: #606266">
            <i v-if="isShowPanel" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </div>
      </div>
      <b-collapse v-model="isShowPanel" id="collapse-panel">
        <div class="thumb-example" v-if="isDisplay">
          <swiper :options="swiperOption" class="mt-3" ref="swiperSingle">
            <swiper-slide v-for="(item, index) in tableData" :key="index">
              <div class="swiper-zoom-container">
                <img
                  :src="item.scmImageUrl"
                  @click="imageView(index, tableData)"
                />
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination swiper-pagination-bullets"
              slot="pagination"
            ></div>
            <div class="swiper-button-prev" slot="button-prev">
              <i class="fa fa-chevron-circle-left icon-font" />
            </div>
            <div class="swiper-button-next" slot="button-next">
              <i class="fa fa-chevron-circle-right icon-font" />
            </div>
          </swiper>
        </div>
        <div v-show="false" ref="viewBigScmImage" v-viewer="{ movable: true }">
          <img
            v-for="(item, index) in viewerImageList"
            :src="item.scmImageUrl"
            :key="index"
          />
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay
  // Controller,
} from 'swiper'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay])
export default {
  components: { Swiper, SwiperSlide },
  props: {
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isShowPanel: true,
      isDisplay: true,
      isBusy: false,
      swiperOption: {
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionTop: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      tableData: [],
      viewerImageList: []
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    init(params) {
      this.getData(params)
    },
    //过滤图片数据
    filterImage(data) {
      const filter = ['jpeg', 'png', 'jpg', 'gif']
      return data.filter((item) => {
        return filter.includes(
          item.scmImageCode.substring(item.scmImageCode.indexOf('.') + 1)
        )
      })
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .opaScmImageListApi(params)
        .then((res) => {
          this.isBusy = false
          this.tableData = this.filterImage(res.body.data)
          if (this.tableData.length > 0) {
            this.isDisplay = true
          } else {
            this.isDisplay = false
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    // 点击大图显示图片预览组件
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const tempViewer = this.$refs.viewBigScmImage.$viewer
        this.viewerImageList = imageList
        tempViewer.view(index)
        tempViewer.show()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-slide {
  height: 400px;
}

.swiper-button-next {
  right: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.swiper-button-prev {
  left: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.icon-font {
  font-size: 2.2rem;
}

.card {
  margin: 20px 10px;
}
</style>
